import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import styled from 'styled-components';
import { darken, setLightness } from 'polished';
import Space from './Space';
var BannerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top: solid 3px ", ";\n  background-color: ", ";\n  padding: 0.5rem 1rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])), function (props) {
  return props.hideTopBorder ? 'none' : props.borderTopColor || darken(0.5, props.theme.colors[props.type]);
}, function (props) {
  return setLightness(0.95, props.theme.colors[props.type]);
});
var BannerIconContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-right: 1rem;\n  align-self: start;\n  color: ", ";\n"])), function (props) {
  return darken(0.5, props.theme.colors[props.type]);
});
var BannerTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), function (props) {
  return props.theme.fontSizes.medium;
});
var BannerBody = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), function (props) {
  return props.theme.fontSizes.small;
});

var Banner = function Banner(_ref) {
  var action = _ref.action,
      children = _ref.children,
      borderTopColor = _ref.borderTopColor,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      _ref$hideTopBorder = _ref.hideTopBorder,
      hideTopBorder = _ref$hideTopBorder === void 0 ? false : _ref$hideTopBorder,
      iconContainerClasses = _ref.iconContainerClasses,
      _ref$containerClasses = _ref.containerClasses,
      containerClasses = _ref$containerClasses === void 0 ? '' : _ref$containerClasses,
      titleClasses = _ref.titleClasses,
      bodyClasses = _ref.bodyClasses,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement(BannerContainer, {
    type: type,
    borderTopColor: borderTopColor,
    className: "".concat([containerClasses, className].join(' ')),
    hideTopBorder: hideTopBorder
  }, /*#__PURE__*/React.createElement(BannerIconContainer, {
    className: iconContainerClasses,
    type: type
  }, /*#__PURE__*/React.createElement(InfoCircleFilled, {
    style: {
      color: borderTopColor
    }
  })), /*#__PURE__*/React.createElement(Space, {
    direction: "vertical",
    size: 5
  }, title && /*#__PURE__*/React.createElement(BannerTitle, {
    className: titleClasses
  }, title), /*#__PURE__*/React.createElement(BannerBody, {
    className: bodyClasses
  }, children)), action);
};

export default Banner;